import React from "react";
import { Row, Col } from "react-bootstrap";

export default React.createClass({

    componentWillMount() {
        this.setState({
            value: this.props.value
        })
    },

    render: function() {

        var dataSource = this.props.dataSource
        dataSource.forEach(function (item, key) {
        	dataSource[key]['applicationNumber'] = key+1;
        });


        // Sort applications with most usage
        if(dataSource.length == 1) {
          dataSource[0]['lastTwoWeeksUsage'] = 10000;
        }
        else {
          for(i=0; i<=dataSource.length; i++) {
            dataSource.sort(function(a,b){
              // Display production application in top
              if(a.hasLicenseAuthorizations == true) {
                a.lastTwoWeeksUsage = 10000;
              }
              return b.lastTwoWeeksUsage - a.lastTwoWeeksUsage;
            });
          }
        }

        return (
            <div className="application-table account-table">
                <div className="account-table-header">
                    <div className="account-table-left">
                        <span className="application-name account-name">Name</span>
                        <span className="hidden-mobile">Device Key  Identifier</span>
                    </div>
                    <div className="account-table-right">
                        <span>Usage</span>
                        <span>Production Key</span>
                        <span>Expand</span>
                    </div>
                </div>
                <div className="account-table-body">
                    {dataSource.map(this.renderRow)}
                </div>
            </div>
        );
    },

    renderRow: function(item) {

        // This file is used for both Company applications (where the permission to edit exists on the company object)
        // And for "Shared" applications, the legacy system, where permissions exist on independent applications
        // On the "Shared" table the default permission is false here, but we need to read the perm on the application object and use that
        var canEdit = this.props.canEdit;
        if (item.roles && item.roles.length && item.roles.indexOf("EDIT") > -1){
            canEdit = true;
        }

        return <this.props.row
          {...item}
          key={item.appToken}
          company={this.props.company}
          canEdit={canEdit}
          canAdministerUsers={this.props.canAdministerUsers}
          showApplicationRoles={this.props.showApplicationRoles}
          logsFound={this.props.logsFound}
        />;
    },

});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-application.jsx